import THEME from 'pobble-components/dist/theme'
import { hover } from 'pobble-components/dist/jss-mixins'

const { COLORS } = THEME

export default {
  link: {
    color: COLORS.BLUE.NORMAL,
    fontWeight: 'bold',
    textDecoration: 'none',
    cursor: 'pointer',
    ...hover({
      color: COLORS.BLUE.FADED
    })
  }
}
